<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import bannerSvc from "@/services/banner";
import { toast } from "vue3-toastify";
import { required, helpers } from "@vuelidate/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Manage Video Background",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Manage Video Background",
      role:
        localStorage.getItem("userInfo") !== null
          ? JSON.parse(localStorage.getItem("userInfo")).role
          : "user",
      video: "",
      submitted: false,
      isLoading: false,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    video: {
      // required: requiredIf(function () {
      //   return this.video === "";
      // }),
      required: helpers.withMessage("Video is required", required),
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      bannerSvc
        .getAllVideoBackground()
        .then((resp) => {
          const video = resp.data.data;
          this.video = video === null ? "" : video;
        })
        .catch((err) => {
          console.log(err);
          toast.error("data not found", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          this.$router.push("/");
        });
    },
    uploadVideo() {
      this.isLoading = true;
      const formData = new FormData();

      for (const element of this.$refs.file.files) {
        let file = element;
        formData.append("images", file);
      }

      bannerSvc
        .uploadFile(formData)
        .then((resp) => {
          resp.data.data.forEach((image) => {
            this.video = {
              uuid: image.url,
              url: image.url,
              originName: image.originName,
            };
          });
        })
        .finally(() => {
          this.$refs.file.value = "";
          this.isLoading = false;
        });
    },
    handleSubmit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      } else {
        this.submitted = false;

        if (this.submitted) {
          return;
        }

        const dataImage = {
          priority: 1,
          url: this.video.url,
          originName: this.video.originName,
        };

        bannerSvc
          .updateVideoBackground({ images: dataImage })
          .catch((err) => {
            toast.error(err, {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          })
          .finally(() => {
            this.submitted = false;
            this.get();
            toast.success("Updated Successfully", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
          });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <form class="needs-validation" @submit.prevent="handleSubmit()">
            <div class="row">
              <div class="col-md-12">
                <video
                  v-if="video.url"
                  title="video-background"
                  controls
                  :src="video.url"
                  width="500"
                >
                  <track
                    kind="subtitles"
                    src="subtitles.vtt"
                    srclang="en"
                    label="English"
                  />
                </video>
              </div>
              <div class="col-md-12">
                <div class="mb-3 position-relative">
                  <label for=""
                    >Video (.MP4) <span class="is-required">*</span></label
                  >
                  <input
                    :disabled="isLoading"
                    id="remark"
                    type="file"
                    ref="file"
                    accept="video/mp4"
                    @change="uploadVideo"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && v$.video.$error,
                    }"
                  />
                  <div v-if="isLoading" class="mt-2 msg-warning">
                    <h7>Please wait for the upload.</h7>
                  </div>
                  <div
                    v-if="submitted && v$.video.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="v$.video.required.$message">{{
                      v$.video.required.$message
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm-end">
              <button
                :disabled="isLoading"
                class="btn btn-success ms-1"
                type="submit"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
span.is-required,
.msg-warning {
  color: red;
}
.album-drag {
  display: inline-flex;
  margin: 10px;
  width: 245px !important;
  height: 300px !important;
}
.album-drag .image {
  text-align: center;
}
.album-drag .btn-delete {
  text-align: center;
  margin-top: 10px;
}
.album-drag img {
  max-width: 200px;
  max-height: 200px;
}
div.upload-thumbnail .delete-attachment {
  color: red;
}
.invalid-feedback-custom {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f46a6a;
}
</style>
